import { httpCreate } from './http';
import conf from '@/config';

const http = httpCreate(conf.apipath + '/sms');

export const sms = {
	smsCode(data) {
		return http.post('/smsCode', data);
	},
};
